import { UsersRound } from "lucide-react";

export const CommunityIcon = ({
  size = 24,
  color = 'currentColor',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.6633 20.1716C19.9383 20.1947 20.2165 20.2065 20.4974 20.2065C21.6622 20.2065 22.7805 20.0039 23.8201 19.6314C23.8271 19.5415 23.8307 19.4505 23.8307 19.3587C23.8307 17.4857 22.3383 15.9674 20.4974 15.9674C19.8 15.9674 19.1527 16.1853 18.6175 16.5577M19.6633 20.1716C19.6634 20.1833 19.6634 20.1949 19.6634 20.2065C19.6634 20.4609 19.6496 20.7119 19.6228 20.959C17.6709 22.0985 15.4085 22.75 12.9967 22.75C10.5848 22.75 8.32249 22.0985 6.37051 20.959C6.34371 20.7119 6.32995 20.4609 6.32995 20.2065C6.32995 20.1949 6.32998 20.1833 6.33004 20.1718M19.6633 20.1716C19.6567 18.8416 19.2739 17.6021 18.6175 16.5577M18.6175 16.5577C17.4332 14.6732 15.3583 13.4239 12.9967 13.4239C10.6353 13.4239 8.56069 14.6729 7.37628 16.557M7.37628 16.557C6.84132 16.185 6.19435 15.9674 5.49742 15.9674C3.65646 15.9674 2.16406 17.4857 2.16406 19.3587C2.16406 19.4505 2.16765 19.5415 2.17468 19.6314C3.21429 20.0039 4.3326 20.2065 5.49742 20.2065C5.77781 20.2065 6.05549 20.1948 6.33004 20.1718M7.37628 16.557C6.71963 17.6016 6.3366 18.8414 6.33004 20.1718M16.33 6.6413C16.33 8.51427 14.8376 10.0326 12.9967 10.0326C11.1557 10.0326 9.66331 8.51427 9.66331 6.6413C9.66331 4.76834 11.1557 3.25 12.9967 3.25C14.8376 3.25 16.33 4.76834 16.33 6.6413ZM22.9968 10.0326C22.9968 11.4373 21.8775 12.5761 20.4967 12.5761C19.116 12.5761 17.9967 11.4373 17.9967 10.0326C17.9967 8.62788 19.116 7.48913 20.4967 7.48913C21.8775 7.48913 22.9968 8.62788 22.9968 10.0326ZM7.99663 10.0326C7.99663 11.4373 6.87733 12.5761 5.49661 12.5761C4.11589 12.5761 2.99659 11.4373 2.99659 10.0326C2.99659 8.62788 4.11589 7.48913 5.49661 7.48913C6.87733 7.48913 7.99663 8.62788 7.99663 10.0326Z"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    // <UsersRound
    //   stroke="var(--color-people-blue)"
    //   strokeWidth={1.25}
    // />
  );
};
export default CommunityIcon;
